// =======================
// src/api/api.js
// =======================

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchDocumentoPdf = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    credentials: "include",
    headers: {
      Accept: "application/pdf",
      ...options.headers,
    },
  });

  if (!response.ok) {
    throw new Error(
      `Não foi possível carregar o documento (${response.status}).`,
    );
  }

  const contentType = response.headers.get("content-type") || "";

  if (!contentType.toLowerCase().includes("application/pdf")) {
    throw new Error("O servidor não retornou um arquivo PDF.");
  }

  return response.blob();
};

export const api = {
  // auth
  login: () => `${API_BASE_URL}/usuarios/login`,
  auth: () => `${API_BASE_URL}/usuarios/me`,
  renewSession: () => `${API_BASE_URL}/usuarios/renovar-sessao`,
  verify: () => `${API_BASE_URL}/usuarios/verificar`,
  forgotPassword: () => `${API_BASE_URL}/usuarios/esqueci-senha`,
  resetPassword: () => `${API_BASE_URL}/usuarios/redefinir-senha`,

  // perfil do administrador
  updateProfileName: () => `${API_BASE_URL}/usuarios/me/nome`,
  requestProfileEmailChange: () => `${API_BASE_URL}/usuarios/me/email`,
  confirmProfileEmailChange: () =>
    `${API_BASE_URL}/usuarios/confirmar-alteracao-email`,
  updateProfilePassword: () => `${API_BASE_URL}/usuarios/me/senha`,

  // register
  register: () => `${API_BASE_URL}/usuarios/cadastrar`,

  // school
  registerSchool: () => `${API_BASE_URL}/mantenedora/cadastrar/escola`,
  listAllSchools: () => `${API_BASE_URL}/processos/listar/todas/escolas`,
  listModalities: () => `${API_BASE_URL}/processos/listar/todas/modalidades`,

  // process creation
  fetchDocuments: (processId, solicitacao) =>
    `${API_BASE_URL}/criacao/processos/${processId}/documentos${solicitacao ? `?solicitacao=${encodeURIComponent(solicitacao)}` : ""}`,
  uploadDocs: () => `${API_BASE_URL}/processos/upload`,
  createProcess: () => `${API_BASE_URL}/processos/criarProcesso`,
  registerProcess: () => `${API_BASE_URL}/processos/registrar`,
  processRequest: (chave) =>
    `${API_BASE_URL}/processos/solicitacoes/${encodeURIComponent(chave)}`,

  // user data
  listUserSchools: () => `${API_BASE_URL}/mantenedora/listar/escolas/usuario`,
  listGeneralProcesses: () =>
    `${API_BASE_URL}/processos/listar/processos-gerais`,
  registerMaintainer: () => `${API_BASE_URL}/mantenedora/registrar`,

  // profile
  maintainerActs: () => `${API_BASE_URL}/atos/perfil-mantenedora`,
  maintainerData: () => `${API_BASE_URL}/mantenedora/usuario/minha`,
  schoolActs: (idEscola) => `${API_BASE_URL}/atos/perfil-escola/${idEscola}`,

  // processes
  getProcess: (processId) => `${API_BASE_URL}/processos/${processId}`,
  getProcessDocs: (processId) =>
    `${API_BASE_URL}/processos/${processId}/documentos`,
  userDocumentHistory: (documentId) =>
    `${API_BASE_URL}/processos/documentos/${documentId}/historico`,
  userHistoryAttachment: (historyId) =>
    `${API_BASE_URL}/processos/historico/${historyId}/anexo`,
  getDocumentoConteudo: (id) =>
    `${API_BASE_URL}/processos/documento/${id}/conteudo`,
  updateDoc: (documentId) =>
    `${API_BASE_URL}/processos/${documentId}/documento`,
  listProcessTypes: () => `${API_BASE_URL}/processos/listar/tipos/processos`,
  statusProcess: (id) => `${API_BASE_URL}/processos/documentos/${id}`,

  // review
  pending: () => `${API_BASE_URL}/cadastros/pendentes`,
  instData: (tipo, id) => `${API_BASE_URL}/cadastros/${tipo}/${id}`,
  approve: (tipo, id) => `${API_BASE_URL}/cadastros/aprovar/${tipo}/${id}`,
  reject: (tipo, id) => `${API_BASE_URL}/cadastros/recusar/${tipo}/${id}`,
  edit: (tipo, id) => `${API_BASE_URL}/cadastros/editar/${tipo}/${id}`,

  allProcAna: () => `${API_BASE_URL}/processos/analyst/listar/processos`,
  approveDoc: (documentId) =>
    `${API_BASE_URL}/processos/analyst/${documentId}/aprovar`,
  resentDoc: (documentId) =>
    `${API_BASE_URL}/processos/analyst/${documentId}/devolver`,
  analystDocumentHistory: (documentId) =>
    `${API_BASE_URL}/processos/analyst/documentos/${documentId}/historico`,
  analystHistoryAttachment: (historyId) =>
    `${API_BASE_URL}/processos/analyst/historico/${historyId}/anexo`,
  schoolDetails: (id) =>
    `${API_BASE_URL}/processos/analyst/escola/detalhada/${id}`,
  allSchools: () => `${API_BASE_URL}/processos/analyst/listar/todas/escolas`,
  maintainerDetails: (id) =>
    `${API_BASE_URL}/processos/analyst/listar/${id}/mantenedoras`,
  allMaintainers: () =>
    `${API_BASE_URL}/processos/analyst/listar/todas/mantenedoras`,
  analystDocumentOrder: (id) => `${API_BASE_URL}/processos/analyst/${id}/ordem-documentos`,
  analystProcesses: (id) => `${API_BASE_URL}/processos/analyst/${id}`,
  analystDocumentoConteudo: (id) =>
    `${API_BASE_URL}/processos/analyst/documento/${id}/conteudo`,
  analystSei: (id) => `${API_BASE_URL}/processos/analyst/${id}/sei`,
  analystPortaria: (id) => `${API_BASE_URL}/processos/analyst/${id}/portaria`,
  listMantUsers: () => `${API_BASE_URL}/processos/analyst/listar/usuarios`,
  editInfoMant: (id) =>
    `${API_BASE_URL}/processos/analyst/listar/usuario/${id}`,
  lisUsers: () => `${API_BASE_URL}/processos/analyst/perfil`,
  AllProcFini: () =>
    `${API_BASE_URL}/processos/analyst/listar/processos/concluidos`,
  AssociateProcessAna: (id) =>
    `${API_BASE_URL}/processos/analyst/${id}/associar-analista`,
  DisassociateProcessAna: (id) =>
    `${API_BASE_URL}/processos/analyst/${id}/desatribuir-analista`,
  NotifyAna: () => `${API_BASE_URL}/processos/analyst/notificacoes`,
  NotifyUser: () => `${API_BASE_URL}/processos/notificacoes`,
  notificationsFeed: () => `${API_BASE_URL}/notificacoes`,
  notificationsEvents: () => `${API_BASE_URL}/notificacoes/eventos`,

  notificationRead: (id) => `${API_BASE_URL}/notificacoes/${id}/ler`,
  notificationsReadAll: () => `${API_BASE_URL}/notificacoes/ler-todas`,
  notificationsClear: () => `${API_BASE_URL}/notificacoes`,

  // admin
  adminListDocs: () => `${API_BASE_URL}/admin/listar/documentos`,
  adminRegisterDoc: () => `${API_BASE_URL}/admin/registrar/documentos`,
  adminUpdateDoc: (documentId) =>
    `${API_BASE_URL}/admin/atualizar/documento/${documentId}`,
  adminDeleteDoc: (id) => `${API_BASE_URL}/admin/deletar/documento/${id}`,
  // Catálogo global de ensino — ADMIN
  catalogoEnsino: () => `${API_BASE_URL}/catalogo-ensino`,

  catalogoEnsinoCategoria: (tipo) =>
    `${API_BASE_URL}/catalogo-ensino/${encodeURIComponent(tipo)}`,

  catalogoEnsinoItem: (tipo, id) =>
    `${API_BASE_URL}/catalogo-ensino/${encodeURIComponent(tipo)}/${encodeURIComponent(id)}`,

  // consulta de impacto antes da exclusão de documento
  adminDocumentLinkedProcesses: (id) =>
    `${API_BASE_URL}/admin/documento/${id}/processos-vinculados`,

  adminCreateModality: () => `${API_BASE_URL}/admin/criar/modalidade`,
  adminGetModality: (id) => `${API_BASE_URL}/admin/listar/modalidade/${id}`,
  adminEditModality: (id) => `${API_BASE_URL}/admin/atualizar/modalidade/${id}`,
  adminListAllModalities: () =>
    `${API_BASE_URL}/admin/listar/todas/modalidades`,
  adminDeleteModality: (id) => `${API_BASE_URL}/admin/deletar/modalidade/${id}`,

  adminSearchProcess: (id) => `${API_BASE_URL}/admin/buscar/processo/${id}`,
  adminDeleteProcessDoc: (processoId, documentoId) =>
    `${API_BASE_URL}/admin/deletar/${processoId}/documentos/${documentoId}`,
  adminUpdateProcess: (processoId) =>
    `${API_BASE_URL}/admin/atualizar/processo/${processoId}`,

  adminSearchDocsProcess: () =>
    `${API_BASE_URL}/admin/buscar/processos/documentos`,
  adminDeleteProcess: (id) => `${API_BASE_URL}/admin/deletar/processo/${id}`,
  adminCreateProcessType: () => `${API_BASE_URL}/admin/criar/tipo/processo`,
  adminRegister: () => `${API_BASE_URL}/admin/cadastrar`,
  adminListUsers: () => `${API_BASE_URL}/admin/usuarios`,
  adminDeleteUsers: (id) => `${API_BASE_URL}/admin/usuarios/${id}`,
  adminUpdateUserAccess: (id) => `${API_BASE_URL}/admin/${id}/acesso-lista`,
  adminUpdateUser: (id) => `${API_BASE_URL}/admin/usuarios/${id}`,

  // cities
  listCities: () => `${API_BASE_URL}/cities`,
  getCity: (id) => `${API_BASE_URL}/cities/${id}`,
  createCity: () => `${API_BASE_URL}/cities`,
  updateCity: (id) => `${API_BASE_URL}/cities/${id}`,
  deleteCity: (id) => `${API_BASE_URL}/cities/${id}`,
  listAvailableCities: () => `${API_BASE_URL}/cities/available`,
  listAvailableCitiesForSre: (sreId) =>
    `${API_BASE_URL}/cities/available-for-sre/${sreId}`,
  listCitiesWithSre: () => `${API_BASE_URL}/cities/with-sre`,

  // SREs
  listSres: () => `${API_BASE_URL}/sres`,
  getSre: (id) => `${API_BASE_URL}/sres/${id}`,
  createSre: () => `${API_BASE_URL}/sres`,
  updateSre: (id) => `${API_BASE_URL}/sres/${id}`,
  deleteSre: (id) => `${API_BASE_URL}/sres/${id}`,

  // disponibilidade dos dados institucionais da SRE
  checkSreDataAvailability: ({ nomeSre, emailInstitucional } = {}) => {
    const params = new URLSearchParams();

    if (nomeSre) {
      params.set("nomeSre", nomeSre);
    }

    if (emailInstitucional) {
      params.set("emailInstitucional", emailInstitucional);
    }

    const query = params.toString();

    return `${API_BASE_URL}/sres/dados/disponibilidade${
      query ? `?${query}` : ""
    }`;
  },

  // gestão de acesso da SRE pelo administrador
  checkSreAccessAvailability: ({ nomeUsuario, emailAcesso } = {}) => {
    const params = new URLSearchParams();

    if (nomeUsuario) {
      params.set("nomeUsuario", nomeUsuario);
    }

    if (emailAcesso) {
      params.set("emailAcesso", emailAcesso);
    }

    const query = params.toString();

    return `${API_BASE_URL}/sres/acesso/disponibilidade${
      query ? `?${query}` : ""
    }`;
  },

  getSreAccess: (id) => `${API_BASE_URL}/sres/${id}/acesso`,
  updateSreAccessPassword: (id) => `${API_BASE_URL}/sres/${id}/acesso/senha`,

  // fluxo existente da própria SRE
  updateSreCredentials: () => `${API_BASE_URL}/sres/trocar-credenciais`,

  linkCityToSre: (sreId) => `${API_BASE_URL}/sres/${sreId}/cities`,

  RecusarProcesso: (id) => `${API_BASE_URL}/processos/analyst/${id}`,

  // catálogo de modelos
  listModels: () => `${API_BASE_URL}/modelos`,
  createModel: () => `${API_BASE_URL}/modelos`,
  updateModel: (id) => `${API_BASE_URL}/modelos/${id}`,
  deleteModel: (id) => `${API_BASE_URL}/modelos/${id}`,
  downloadModel: (id) => `${API_BASE_URL}/modelos/${id}/download`,

  // categorias
  listModelCategories: () => `${API_BASE_URL}/modelos/categorias`,
  createModelCategory: () => `${API_BASE_URL}/modelos/categorias`,
  updateModelCategory: (id) => `${API_BASE_URL}/modelos/categorias/${id}`,
  deleteModelCategory: (id) => `${API_BASE_URL}/modelos/categorias/${id}`,

  // assuntos
  listModelSubjects: () => `${API_BASE_URL}/modelos/assuntos`,
  createModelSubject: () => `${API_BASE_URL}/modelos/assuntos`,
  updateModelSubject: (id) => `${API_BASE_URL}/modelos/assuntos/${id}`,
  deleteModelSubject: (id) => `${API_BASE_URL}/modelos/assuntos/${id}`,

  // etapas e modalidades dos modelos
  listModelStagesModalities: () => `${API_BASE_URL}/modelos/etapas-modalidades`,

  createModelStageModality: () => `${API_BASE_URL}/modelos/etapas-modalidades`,

  updateModelStageModality: (id) =>
    `${API_BASE_URL}/modelos/etapas-modalidades/${id}`,

  deleteModelStageModality: (id) =>
    `${API_BASE_URL}/modelos/etapas-modalidades/${id}`,

  // misc
  logout: () => `${API_BASE_URL}/usuarios/logout`,
  fetchActs: (perfil, id) => `${API_BASE_URL}/atos/${perfil}/${id}`,
  updateAct: (perfil, id, atoId) =>
    `${API_BASE_URL}/atos/${perfil}/${id}/${atoId}`,
  deleteAct: (perfil, id, atoId) =>
    `${API_BASE_URL}/atos/${perfil}/${id}/${atoId}`,
};
